import { render } from "./empty-box.vue?vue&type=template&id=1cd27e54&scoped=true"
import script from "./empty-box.vue?vue&type=script&lang=js"
export * from "./empty-box.vue?vue&type=script&lang=js"

import "./empty-box.vue?vue&type=style&index=0&id=1cd27e54&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd27e54"]])

export default __exports__